import { ListItem, ListItemProps } from '@chakra-ui/react';
import React from 'react';

export const MenuListItem = (props: ListItemProps) => {
  return <ListItem p={2} _hover={{ background: 'blackAlpha.200', cursor: 'pointer' }} {...props} />;
};
